module.exports = __webpack_public_path__ + "img/375.bcb799d6.jpg";